import type { TeamMemberModel } from '@/adapters/apiv1.g';
import { extractUserProfile } from '@/adapters/shared/users/extract-user-profile';
import type { TeamMember } from '@/types/core/team';
import type { UUID } from '@/utils/uuid';

/**
 * Transform a backend TeamMemberModel to a frontend TeamMember type.
 * @param model - API TeamMemberModel response
 * @returns TeamMember - UI-friendly TeamMember object
 */
export function extractTeamMember(model: TeamMemberModel): TeamMember {
  return {
    userId: model.user_id as UUID,
    teamMemberId: model.team_member_id as UUID | undefined,
    teamId: model.team_id as UUID | undefined,
    tenantId: model.tenant_id as UUID | undefined,
    name: model.profile?.name,
    email: model.profile?.email,
    photoUrl: model.profile?.photo_url,
    profile: model.profile ? extractUserProfile(model.profile) : undefined,
    assigned: model.assigned,
    assignedAt: model.assigned_at,
    revokedAt: model.revoked_at,
  };
}
